"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const Lock_1 = tslib_1.__importDefault(require("@mui/icons-material/Lock"));
const Grid_1 = tslib_1.__importDefault(require("@mui/material/Grid"));
const Typography_1 = tslib_1.__importDefault(require("@mui/material/Typography"));
const ButtonContactUs_1 = tslib_1.__importDefault(require("../ButtonContactUs"));
const CardActionsError_1 = tslib_1.__importDefault(require("../CardActionsError"));
const CardContentError_1 = tslib_1.__importDefault(require("../CardContentError"));
const CardError_1 = tslib_1.__importDefault(require("../CardError"));
const CardTitleError_1 = tslib_1.__importDefault(require("../CardTitleError"));
/**
 *
 * @category component
 */
const PageAccessDenied = ({ small = false, contact, errorCardProps }) => (react_1.default.createElement(Grid_1.default, { container: true, justifyContent: "center", alignItems: "center", spacing: 1 },
    react_1.default.createElement(CardError_1.default, { ...errorCardProps },
        react_1.default.createElement(CardTitleError_1.default, { small: small, Icon: Lock_1.default, subtitle: "Access Denied" }),
        react_1.default.createElement(CardContentError_1.default, { small: small },
            react_1.default.createElement(Typography_1.default, { variant: "body2", color: "textSecondary", align: small ? "left" : "center" }, "Try using the main menu to get back"),
            react_1.default.createElement(Typography_1.default, { variant: "body2", color: "textSecondary", align: small ? "left" : "center" }, `If you have any questions or you are supposed to have access, please contact ${contact}`)),
        react_1.default.createElement(CardActionsError_1.default, null,
            react_1.default.createElement(ButtonContactUs_1.default, { title: "Access Denied", email: contact, body: "" })))));
exports.default = PageAccessDenied;
